import { Select } from "antd";
import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import type { LabelValue } from "~types/labelValue";

import "./SelectUserRole.scss";

type UserRoleViewProps = {
  label?: ReactNode;
  value?: string | number;
};

const UserRoleView = ({ label, value }: UserRoleViewProps) => (
  <div className="permissions-user-role-option">
    <span className="permissions-user-role-option-title">{label}</span>
    <span className="permissions-user-role-option-subtitle">
      <FormattedMessage id={`form.help.permissions.role.userRole.${value}.extra`} />
    </span>
  </div>
);

type SelectUserRoleProps = {
  disabled: boolean;
  options: LabelValue[];
  value?: string;
  onChange: () => void;
};

const SelectUserRole = ({ disabled, options, onChange, value }: SelectUserRoleProps) => (
  <Select
    classNames={{
      root: "permissions-select-user-role",
      popup: {
        root: "permissions-select-user-role",
      },
    }}
    showSearch={false}
    disabled={disabled}
    options={options}
    value={value}
    listHeight={400}
    placeholder={<FormattedMessage id="form.permissions.role.userRole.placeholder" />}
    optionRender={UserRoleView}
    labelRender={UserRoleView}
    onChange={onChange}
  />
);

export default SelectUserRole;
